import originalDayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import minMax from "dayjs/plugin/minMax";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { DEFAULT_TIMEZONE } from "../../lib/constants/constants";

export type { Dayjs } from "dayjs";

// プラグインを拡張
originalDayjs.extend(utc);
originalDayjs.extend(timezone);
originalDayjs.extend(customParseFormat);
originalDayjs.extend(minMax);
originalDayjs.extend(isSameOrBefore);
originalDayjs.extend(isSameOrAfter);
originalDayjs.tz.setDefault(DEFAULT_TIMEZONE);

// 拡張された dayjs 関数
type DayjsInput = Parameters<typeof originalDayjs>[0];
type DayjsFormatInput = string | undefined;
type DayjsStrictInput = boolean | undefined;

interface ExtendedDayjs {
  (
    date?: DayjsInput,
    format?: DayjsFormatInput,
    strict?: DayjsStrictInput,
  ): originalDayjs.Dayjs;
  extend: typeof originalDayjs.extend;
  tz: typeof originalDayjs.tz;
  utc: typeof originalDayjs.utc;
  unix: typeof originalDayjs.unix;
  locale: typeof originalDayjs.locale;
  max: typeof originalDayjs.max;
  min: typeof originalDayjs.min;
  // その他の dayjs の静的メソッド
}

// 拡張された dayjs 関数を作成
const dayjs = ((
  date?: DayjsInput,
  format?: DayjsFormatInput,
  strict?: DayjsStrictInput,
) => {
  if (format !== undefined) {
    return originalDayjs(date, format, strict).tz();
  }
  return originalDayjs(date).tz();
}) as ExtendedDayjs;

// 静的メソッドをコピー
dayjs.extend = originalDayjs.extend;
dayjs.tz = originalDayjs.tz;
dayjs.utc = originalDayjs.utc;
dayjs.unix = originalDayjs.unix;
dayjs.locale = originalDayjs.locale;
dayjs.max = originalDayjs.max;
dayjs.min = originalDayjs.min;

/**
 * TODO: lib/utils/fiscal-year.tsが存在しているのでそちらに統合する
 */
export const getCurrentFiscalYear = (date = dayjs()) => {
  const month = date.month() + 1;
  return month >= 4 ? date.year() : date.year() - 1;
};

export default dayjs;
